import React from 'react';
import { injectIntl } from 'react-intl';
import { Alert } from 'react-bootstrap';

import RichEditorContent from 'components/RichEditorContent';

import AbstractTimelineEvent from './AbstractTimelineEvent';

class TimelineTextMessageSent extends AbstractTimelineEvent {
  constructor(props) {
    super(props);

    this.state = {
      showDetails: false,
    };
  }

  showDetails = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ showDetails: true });
  };

  render() {
    const {
      intl: { messages },
      event,
    } = this.props;
    const { showDetails } = this.state;

    return (
      <div className="card-block">
        <RichEditorContent content={'<div>' + event.getText() + '</div>'} />

        {event && event.getDynParams() && event.getDynParams().length ? (
          <div className="p-t-10">
            {showDetails ? (
              <RichEditorContent content={'<div>' + this.getDynParam('textMessageContent', '') + '</div>'} />
            ) : (
              <a href="#details" onClick={this.showDetails}>
                <i className="fal fa-angle-double-right" /> {messages.show_details}
              </a>
            )}
          </div>
        ) : (
          <Alert>{messages.no_details_available}</Alert>
        )}
      </div>
    );
  }
}

export default injectIntl(TimelineTextMessageSent);
